export default "__VITE_ASSET__BhbmfuMz__"